import(/* webpackMode: "eager" */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\app\\tangerang\\sewa-innova-tangerang\\page.tsx");
